export default __webpack_public_path__ + "static/media/lumbalgia.d013c186.pdf";